import { GetterTree } from 'vuex'

import { RootState, ReceiptState } from '@/types/store'

export const getters: GetterTree<ReceiptState, RootState> = {
  receipt(state): ReceiptState['receipt'] {
    return state.receipt
  },
  receipts(state): ReceiptState['receipts'] {
    return state.receipts
  },
  total(state): ReceiptState['total'] {
    return state.total
  },
  isReceiptsLoading(state): ReceiptState['isReceiptsLoading'] {
    return state.isReceiptsLoading
  },
  searchCondition(state): ReceiptState['searchCondition'] {
    return state.searchCondition
  },
  masterSearchItem(state): ReceiptState['masterSearchItem'] {
    return state.masterSearchItem
  },
  summaries(state): ReceiptState['summaries'] {
    return state.summaries
  },
  isSummariesLoading(state): ReceiptState['isSummariesLoading'] {
    return state.isSummariesLoading
  },
  receiptType(state): ReceiptState['receiptType'] {
    return state.receiptType
  },
}
